import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { 
  LayoutDashboard, 
  ArrowDownToLine, 
  Building2,
  FileSpreadsheet,
  ClipboardCheck,
  Receipt,
  CreditCard,
  PhoneCall,
} from 'lucide-react';

const CORE_NAV_ITEMS = [
  { href: '/finance', label: 'Cockpit', icon: LayoutDashboard },
  { href: '/finance/reconciliation', label: 'Conciliação', icon: PhoneCall },
  { href: '/finance/receivables', label: 'Recebíveis', icon: ArrowDownToLine },
  { href: '/finance/transactions', label: 'Transações', icon: Receipt },
  { href: '/finance/stripe', label: 'Stripe', icon: CreditCard },
  { href: '/finance/bank-accounts', label: 'Importação Bancária', icon: Building2 },
  { href: '/finance/close', label: 'Fechamento', icon: FileSpreadsheet },
  { href: '/finance/reports/payment-audit', label: 'Auditoria', icon: ClipboardCheck },
];

const EXTENDED_NAV_ITEMS = [
  { href: '/finance/cash-flow', label: 'Fluxo de Caixa', icon: FileSpreadsheet },
  { href: '/finance/expenses', label: 'Contas a Pagar', icon: FileSpreadsheet },
  { href: '/finance/reports', label: 'Relatórios', icon: FileSpreadsheet },
  { href: '/finance/budget', label: 'Orçamento', icon: FileSpreadsheet },
  { href: '/finance/settings', label: 'Configurações', icon: FileSpreadsheet },
];

export function FinanceNav() {
  const location = useLocation();
  const showExtendedFinanceNav = import.meta.env.VITE_FINANCE_FULL_NAV === 'true';
  const navItems = showExtendedFinanceNav
    ? [...CORE_NAV_ITEMS, ...EXTENDED_NAV_ITEMS]
    : CORE_NAV_ITEMS;
  
  const isActive = (href: string) => {
    if (href === '/finance') {
      return location.pathname === '/finance';
    }
    return location.pathname.startsWith(href);
  };

  return (
    <nav className="bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 py-3">
      <div>
        <div 
          className={cn(
            "bg-slate-100 dark:bg-slate-800 rounded-full p-1",
            "overflow-x-auto scrollbar-hide",
            "max-w-full"
          )}
        >
          <div className="inline-flex gap-1 min-w-max">
            {navItems.map((item) => {
              const Icon = item.icon;
              const active = isActive(item.href);
              
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  className={cn(
                    'flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-full transition-all whitespace-nowrap',
                    active 
                      ? 'bg-white dark:bg-slate-700 text-primary shadow-sm' 
                      : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100'
                  )}
                >
                  <Icon className="h-4 w-4" />
                  {item.label}
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </nav>
  );
}
